
import { defineComponent, ref } from "@vue/runtime-core";

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    const basePath = ref(process.env.VUE_APP_BASE_URL);

    return { basePath };
  },
});
